import { Grid } from '@mui/material'

import VitalsTable from './table/VitalsTable'

const SoapVitalsWidgetUnlocked = () => (
  <Grid container id="vitals-widget">
    <VitalsTable />
  </Grid>
)

export default SoapVitalsWidgetUnlocked
